import { computed, ref, watch } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/feishuGroup.jpeg';
const _withScopeId = n => (_pushScopeId("data-v-044547e7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "path-header-content"
};
const _hoisted_2 = {
  class: "path-left"
};
const _hoisted_3 = {
  class: "full-path-name"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, "/", -1));
const _hoisted_5 = {
  class: "route-name"
};
const _hoisted_6 = {
  class: "path-right"
};
const _hoisted_7 = {
  class: "header-content bgHeader faceback-btn"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "feishu-group-img",
  alt: ""
}, null, -1));
const _hoisted_9 = {
  class: "header-content bgHeader"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-name"
}, "公告", -1));
const _hoisted_11 = {
  key: 0,
  class: "point"
};
const _hoisted_12 = {
  class: "productIMG"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "txt"
}, "暂无未读消息", -1));
const _hoisted_14 = {
  class: "hornItem_icon"
};
const _hoisted_15 = {
  class: "hornItem_title ellipsis"
};
const _hoisted_16 = {
  class: "hornItem_time"
};
const _hoisted_17 = {
  class: "header-content"
};
const _hoisted_18 = {
  class: "user-name"
};
import { useRoute, useRouter } from 'vue-router';
import testList from '@/components/temCom/testList.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import announcementTemplate from '@/components/announcementTemplate.vue';
import { useStore } from '@/store';
import { ssoLogoutFetch } from '@/api/login';
import { postUpdateUserReadNoticeStatus } from '@/api/systemNotification';
import { OK, dateFormat } from '@/common';
import { useHorn } from '@/hooks/useHorn';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'PathHeader',
  setup(__props, {
    expose
  }) {
    const {
      getUserNotice
    } = useHorn();
    const {
      changeCol
    } = useStore();
    const collapsed = computed(() => useStore().isCollapsed);
    const NoticeInfo = computed(() => useStore().NoticeInfo);
    const route = useRoute(),
      router = useRouter();
    const routeName = ref(''),
      fullPathName = ref(''),
      userInfo = ref();
    const logout = () => {
      ssoLogoutFetch();
      router.push({
        name: 'logout'
      });
    };
    //系统通知相关
    const visibleAnnouncement = ref(false);
    const closeModal = async () => {
      var _NoticeInfo$value;
      const params = {
        noticeIds: (_NoticeInfo$value = NoticeInfo.value) === null || _NoticeInfo$value === void 0 || (_NoticeInfo$value = _NoticeInfo$value.popoverNotice) === null || _NoticeInfo$value === void 0 ? void 0 : _NoticeInfo$value.id
      };
      try {
        const {
          code
        } = await postUpdateUserReadNoticeStatus(params);
        if (code == OK) {
          visibleAnnouncement.value = false;
        }
      } catch (e) {}
    };
    const jumpPage = () => {
      router.push({
        name: 'notificationList'
      });
    };
    const handleFeedback = () => {
      window.open('https://ewe8txd9jt.feishu.cn/share/base/form/shrcn1ow9z9MpMTl4DQGV1Ma2be', '_blank');
    };
    watch(() => useStore().userInfo, n => {
      if (n) {
        userInfo.value = JSON.parse(useStore().userInfo);
      }
    }, {
      immediate: true
    });
    watch(() => NoticeInfo.value, n => {
      if (n !== null && n !== void 0 && n.popoverNotice) {
        visibleAnnouncement.value = true;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => route, n => {
      var _n$meta, _n$meta2;
      routeName.value = (_n$meta = n.meta) === null || _n$meta === void 0 ? void 0 : _n$meta.title;
      fullPathName.value = (_n$meta2 = n.meta) === null || _n$meta2 === void 0 ? void 0 : _n$meta2.pathName;
    }, {
      immediate: true,
      deep: true
    });
    expose({
      getUserNotice
    });
    return (_ctx, _cache) => {
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(SvgIcon, {
        "icon-class": _unref(collapsed) ? 'openMenu' : 'closeMenu',
        "class-name": "close-icon",
        onClick: _unref(changeCol)
      }, null, 8, ["icon-class", "onClick"]), _createElementVNode("div", _hoisted_3, _toDisplayString(fullPathName.value), 1), _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(routeName.value), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_dropdown, {
        placement: "bottomLeft"
      }, {
        overlay: _withCtx(() => [_hoisted_8]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(SvgIcon, {
          "icon-class": "feishuGroup",
          "class-name": "user-icon"
        }), _createTextVNode(" 飞书群 ")])]),
        _: 1
      }), _createElementVNode("div", {
        class: "header-content bgHeader faceback-btn",
        onClick: handleFeedback,
        size: "small"
      }, [_createVNode(SvgIcon, {
        "icon-class": "faceback",
        "class-name": "user-icon"
      }), _createTextVNode(" 需求与反馈 ")]), _createVNode(testList), _createVNode(_component_a_dropdown, {
        placement: "bottomLeft"
      }, {
        overlay: _withCtx(() => {
          var _unref2;
          return [!((_unref2 = _unref(NoticeInfo)) !== null && _unref2 !== void 0 && (_unref2 = _unref2.notReadNotice) !== null && _unref2 !== void 0 && _unref2.length) ? (_openBlock(), _createBlock(_component_a_menu, {
            key: 0
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(SvgIcon, {
              "icon-class": "wushuju"
            }), _hoisted_13]), _createElementVNode("div", {
              class: "lookAll",
              onClick: jumpPage
            }, "查看所有消息")]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_a_menu, {
            key: 1,
            style: {
              "max-height": "232px",
              "overflow-y": "scroll"
            }
          }, {
            default: _withCtx(() => {
              var _unref3;
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref3 = _unref(NoticeInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.notReadNotice, item => {
                return _openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.id,
                  style: {
                    "padding": "2px 5px !important"
                  }
                }, {
                  default: _withCtx(() => [_createElementVNode("div", {
                    class: "hornItem",
                    onClick: jumpPage
                  }, [_createElementVNode("div", _hoisted_14, _toDisplayString(item === null || item === void 0 ? void 0 : item.createUser.slice(0, 1)), 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(dayjs)(item.sendTime).format(_unref(dateFormat))), 1)])])]),
                  _: 2
                }, 1024);
              }), 128))];
            }),
            _: 1
          }))];
        }),
        default: _withCtx(() => {
          var _unref4;
          return [_createElementVNode("div", _hoisted_9, [_createVNode(SvgIcon, {
            "icon-class": "notification",
            "class-name": "user-icon"
          }), _hoisted_10, (_unref4 = _unref(NoticeInfo)) !== null && _unref4 !== void 0 && (_unref4 = _unref4.notReadNotice) !== null && _unref4 !== void 0 && _unref4.length ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true)])];
        }),
        _: 1
      }), _createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            onClick: logout
          }, {
            default: _withCtx(() => [_createTextVNode("退出")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => {
          var _userInfo$value;
          return [_createElementVNode("div", _hoisted_17, [_createVNode(SvgIcon, {
            "icon-class": "userIcon",
            "class-name": "user-icon"
          }), _createElementVNode("div", _hoisted_18, _toDisplayString((_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.name), 1), _createVNode(SvgIcon, {
            "icon-class": "downArrow",
            "class-name": "arrow-icon"
          })])];
        }),
        _: 1
      })]), _createVNode(_component_a_modal, {
        open: visibleAnnouncement.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => visibleAnnouncement.value = $event),
        onCancel: closeModal,
        width: "900px",
        centered: "",
        footer: false
      }, {
        default: _withCtx(() => {
          var _unref5;
          return [_createVNode(announcementTemplate, {
            announcementInfo: (_unref5 = _unref(NoticeInfo)) === null || _unref5 === void 0 ? void 0 : _unref5.popoverNotice
          }, null, 8, ["announcementInfo"])];
        }),
        _: 1
      }, 8, ["open"])]);
    };
  }
});